import type { AgentHandoff, ChatMessage } from "@/types";

/** `messageMetadata.type` of a chat's handoff divider row (MHS-628). */
export const HANDOFF_MESSAGE_TYPE = "agent_handoff";

/** The handoff a divider row carries, or `null` for any other message. */
export function handoffOf(message: ChatMessage): AgentHandoff | null {
  if (message.role !== "system" || message.messageMetadata?.type !== HANDOFF_MESSAGE_TYPE) return null;
  return (message.messageMetadata.handoff as AgentHandoff | undefined) ?? null;
}

/** A divider row for a handoff that just happened (the saved row replaces it on the next load). */
export function makeHandoffMessage(sessionId: number, handoff: AgentHandoff): ChatMessage {
  return {
    id: Date.now(),
    uuid: `handoff-${handoff.uuid}`,
    sessionId,
    role: "system",
    content: "",
    messageMetadata: { type: HANDOFF_MESSAGE_TYPE, handoff },
    createdAt: handoff.createdAt,
  };
}

/** Whether `messages` already show this handoff (a reconnect replays the stream's events). */
export function hasHandoff(messages: ChatMessage[], uuid: string): boolean {
  return messages.some((m) => handoffOf(m)?.uuid === uuid);
}

/** The chat's handoffs, oldest first. */
export function handoffChain(messages: ChatMessage[]): AgentHandoff[] {
  return messages.map(handoffOf).filter((h): h is AgentHandoff => h !== null);
}
